import React from 'react';
import {Route, Redirect as RouterRedirect} from "react-router-dom";

const ProtectedRoute = ({component: Component, loggedUser, ...rest}) => {
    return (
        <Route {...rest}
            render = {props => {
                return loggedUser ? <Component {...props} />
                        : (<RouterRedirect to={{
                            pathname: "/",
                            state: {from: props.location}
                        }}
                    />
                )
            }}
        />
    )
};


export default ProtectedRoute;